__webpack_require__.hmrF = function() { return "tinper-next." + __webpack_require__.h() + ".hot-update.json"; };